import { Route, Routes } from 'react-router';

import PrivateRoute from 'app/components/Util/PrivateRoute';
import { AccessSettingsRoutes } from 'app/containers/Access-Settings';
import { ManagePermissionsSettings } from 'app/containers/Articles/ManagePermissionsSettings';
import { EventSettings } from 'app/containers/Events/EventSettings';
import { IOSettings } from 'app/containers/InternationalOffice/IOSettings';
import { ManageJobmarketSettings } from 'app/containers/Jobmarket/ManageJobmarketSettings';
import { SystemNotificationsList } from 'app/containers/SystemNotifications/SystemNotificationsList';
import Roles from 'utils/enums/Roles';

import MessagesSettings from '../Messaging/MessagesSettings';
import { TileSettings } from './TileSettings';

export const Settings = ({ currentUser }) => {
  return (
    <Routes>
      <Route
        path="access-handler/*"
        element={
          <PrivateRoute requires={{ entitlements: [Roles.SUPER_USER] }} user={currentUser}>
            <AccessSettingsRoutes currentUser={currentUser} />
          </PrivateRoute>
        }
      />
      <Route
        path="articles"
        element={
          <PrivateRoute requires={{ entitlements: [Roles.SUPER_USER] }} user={currentUser}>
            <ManagePermissionsSettings />
          </PrivateRoute>
        }
      />
      <Route
        path="messaging"
        element={
          <PrivateRoute requires={{ entitlements: [Roles.SUPER_USER] }} user={currentUser}>
            <MessagesSettings />
          </PrivateRoute>
        }
      />
      <Route
        path="jobmarket"
        element={
          <PrivateRoute requires={{ entitlements: [Roles.JOBMARKET_ADMIN] }} user={currentUser}>
            <ManageJobmarketSettings />
          </PrivateRoute>
        }
      />
      <Route
        path="io"
        element={
          <PrivateRoute
            requires={{
              entitlements: [Roles.INCOMINGS_ADMIN, Roles.SUPER_USER]
            }}
            user={currentUser}
          >
            <IOSettings />
          </PrivateRoute>
        }
      />
      <Route
        path="system-notifications"
        element={
          <PrivateRoute
            requires={{
              entitlements: [Roles.SUPER_USER]
            }}
            user={currentUser}
          >
            <SystemNotificationsList />
          </PrivateRoute>
        }
      />
      <Route
        path="event"
        element={
          <PrivateRoute requires={{ entitlements: [Roles.SUPER_USER] }} user={currentUser}>
            <EventSettings />
          </PrivateRoute>
        }
      />
      <Route
        path="tile-settings"
        element={
          <PrivateRoute requires={{ entitlements: [Roles.SUPER_USER] }} user={currentUser}>
            <TileSettings />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};
